import './index.scss'
$(".link").hover(function() {
    $(".link ul").stop().slideDown();
},function(){
    $(".link ul").stop().slideUp();
})
